export default [
    {
        path: "profile",
        name: "Profile",
        meta:{
            permissionPath: 'settings.profile',
        },
        component: () =>
            import(
                /* webpackChunkName: "profile" */ "@/views/storePanel/settings/tabs/Profile.vue"
            )
    },

    {
        path: "reward",
        name: "Reward",
        meta:{
            permissionPath: 'settings.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "reward" */ "@/views/storePanel/settings/tabs/Reward.vue"
            )
    },

    {
        path: "product-points",
        name: "ProductPoints",
        meta:{
            permissionPath: 'settings.product_points',
        },
        component: () =>
            import(
                /* webpackChunkName: "productPoints" */ "@/views/storePanel/settings/tabs/ProductPoints.vue"
            )
    },

    {
        path: "users",
        name: "Users",
        meta:{
            permissionPath: 'settings.users.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "users" */ "@/views/storePanel/settings/tabs/Users.vue"
            )
    },

    {
        path: "payment-providers",
        name: "PaymentProviders",
        meta:{
            permissionPath: 'settings.cleaners',
        },
        component: () =>
            import(
                /* webpackChunkName: "cleanerManagement" */ "@/views/storePanel/settings/tabs/PaymentProviders.vue"
            )
    },

    {
        path: "payment-processing",
        name: "PaymentProcessing",
        meta:{
            permissionPath: 'settings.payment_routing',
        },
        component: () =>
            import(
                /* webpackChunkName: "paymentsDirection" */ "@/views/storePanel/settings/tabs/PaymentProcessing.vue"
            )
    },

    {
        path: "cards",
        name: "Cards",
        meta:{
            permissionPath: 'settings.cards',
        },
        component: () =>
            import(
                /* webpackChunkName: "cards" */ "@/views/storePanel/settings/tabs/Cards.vue"
            )
    },


    // {
    //     path: "payment-history",
    //     name: "PaymentHistory",
    //     component: () =>
    //         import(
    //             /* webpackChunkName: "paymentHistory" */ "@/views/storePanel/settings/tabs/PaymentHistory.vue"
    //         )
    // },

    // {
    //     path: "payment-methods",
    //     name: "PaymentMethods",
    //     component: () =>
    //         import(
    //             /* webpackChunkName: "paymentMethods" */ "@/views/storePanel/settings/tabs/PaymentMethods.vue"
    //         )
    // }
];
